import { Component, ElementRef, ViewChild } from "@angular/core";

@Component({
  selector: "app-group-landing-page",
  templateUrl: "./group-landing-page.component.html",
})
export class GroupLandingPageComponent {
  allCards = [
    {
      key: "product",
      tabId: "pills-tailored-product-tab",
      target: "#pills-tailored-product",
    },
    {
      key: "allocation",
      tabId: "pills-seamless-tab",
      target: "#pills-seamless",
    },
    {
      key: "price",
      tabId: "pills-price-Visibility-tab",
      target: "#pills-price-Visibility",
    },
  ];

  cards = [...this.allCards];
  activeKey = "product";
  isClickedFromCard = false;
  @ViewChild("groupSection") groupSection!: ElementRef;

  constructor() {
    this.reorder(this.activeKey);
    window.scrollTo(0, 0);
  }

  reorder(clickedKey: string) {
    this.activeKey = clickedKey;

    const index = this.allCards.findIndex((c) => c.key === clickedKey);
    const total = this.allCards.length;

    const prev = this.allCards[(index - 1 + total) % total];
    const current = this.allCards[index];
    const next = this.allCards[(index + 1) % total];

    this.cards = [prev, current, next];
    if (this.isClickedFromCard) {
      this.scrollToGroupSection();
      this.isClickedFromCard = false;
    }
  }

  onCardClick(key: string) {
    this.isClickedFromCard = true;
    this.reorder(key);
  }

  scrollToGroupSection() {
    setTimeout(() => {
      this.groupSection.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  }
}
